export default "__VITE_PUBLIC_ASSET__20e9977a__"